import { Box, Grid, Skeleton, Typography, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useGetCookieConsentQuery } from '@/services/api/helpApiSlice';
import React, { FC } from 'react';

export const CookieConsentPage: FC = () => {
  const { data, isLoading } = useGetCookieConsentQuery();

  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  return (
    <Grid container={true} direction={'column'} spacing={isMobile ? 2 : 4} sx={{ minHeight: '100%' }} wrap={'nowrap'}>
      <Grid item={true}>
        <Typography
          variant={'h1'}
          sx={{
            fontSize: isMobile ? '32px !important' : '48px',
            lineHeight: isMobile ? '40px !important' : '56px',
            maxWidth: '950px',
          }}>
          {'Согласие на использование файлов cookie и сервиса Яндекс Метрика'}
        </Typography>
      </Grid>
      <Grid item={true} xs={true}>
        {isLoading ? (
          <Skeleton height={'20px'} />
        ) : (
          <Box className={'cookie-consent-content'} dangerouslySetInnerHTML={{ __html: data?.content ?? '' }} />
        )}
      </Grid>
    </Grid>
  );
};
